module.exports = __webpack_public_path__ + "static/media/puzzles-social-image.423dcb6c.png";